import React, { useState, useEffect } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label, Alert, Row, Col } from 'reactstrap';
import { getQuestionList } from '../../api/question';
import { getBadgeList } from '../../api/badge';
import Select from 'react-select';
import { AvField, AvForm } from 'availity-reactstrap-validation';
import SweetAlert from 'react-bootstrap-sweetalert';
import { updateSection } from '../../api/section';

const EditSectionModal = ({ isOpen, toggle, saveSection, section, fetchSections }) => {
  const [name, setName] = useState('');
  const [, setSelectedQuestions] = useState([]);
  const [badges, setBadges] = useState([]);
  const [selectedBadge, setSelectedBadge] = useState()
  const [questions, setQuestions] = useState([]);
  const [question, setQuestion] = useState([])
  const [successAlert, setSuccessAlert] = useState({
    message: '',
    show_alert: false
  });
  const [sectionLoading, setSectionLoading] = useState(false)

  const [requestError, setRequestError] = useState({
    show_alert: false,
    message: ''
  })

  useEffect(() => {
    async function fetchData() {
      const badgeList = await getBadgeList(1, 500);
      const questionList = await getQuestionList(1, 500);
      setBadges(buildOptions(badgeList.data || ""));
      setQuestions(buildOptions(questionList.data));

    }
    fetchData();
  }, []);

  function buildOptions(list) {
    return list.map((item) => ({
      value: item._id,
      label: item.title || item.name
    }));
  }

  const styles = {
    multiValue: (base, state) => {
      return state.data.isFixed ? { ...base, backgroundColor: 'gray' } : base;
    },
    multiValueLabel: (base, state) => {
      return state.data.isFixed
        ? { ...base, fontWeight: 'bold', color: 'white', paddingRight: 6 }
        : base;
    },
    multiValueRemove: (base, state) => {
      return state.data.isFixed ? { ...base, display: 'none' } : base;
    }
  };

  useEffect(() => {
    async function fetchData() {
      const badgeList = await getBadgeList(1, 100);
      const questionList = await getQuestionList(1, 100);
      setBadges(buildOptions(badgeList?.data));
      setQuestions(buildOptions(questionList.data));
    }
    fetchData();
  }, []);

  useEffect(() => {
    if (section) {
      setName(section.name);
      setSelectedBadge(buildOptions([section.badge]));
      setSelectedQuestions(section.questions.map(question => question._id));
      setQuestion(buildOptions(section.questions));
    }
  }, [section]);

  async function handleSubmit(e, values) {
    resetErrorAlert();
    if (question.length === 0) {
      showErrorAlert("Please select atleast one question")
      return
    }
    if (selectedBadge === "" || selectedBadge === undefined) {
      showErrorAlert("Please select Badge")
      return
    }
    setSectionLoading(true)
    let sectionData = {
      name: values.name,
      badge: selectedBadge.value,
      questions: question.map((q) => q.value)
    }
    const { response, error } = await updateSection(section._id, sectionData)
    if (error) {
      showErrorAlert(error.message || "Error in creating section")
      return
    }
    setSelectedBadge("")
    setQuestion([])
    fetchSections()
    toggle()
    showSuccessAlert(response.message)
    setSectionLoading(false)
  };

  const handleQuestionToggle = (selectedData) => {
    setQuestion(selectedData)
  };


  function handleBadgeSelection(selectedItem) {
    setSelectedBadge(selectedItem);
  }


  function showErrorAlert(message) {
    setRequestError({ message: message, show_alert: true });
  }

  function resetErrorAlert() {
    setRequestError({ message: '', show_alert: false });
  }

  function showSuccessAlert(message) {
    setSuccessAlert({ message: message, show_alert: true });
  }

  function resetSuccessAlert() {
    setSuccessAlert({ message: '', show_alert: false });
  }

  function resetState() {
    resetSuccessAlert();
    resetErrorAlert();
  }


  return (
    <React.Fragment>
      {successAlert.show_alert && (
        <SweetAlert success title="Updated" onConfirm={resetState}>
          {successAlert.message}
        </SweetAlert>
      )}
      <Modal isOpen={isOpen} backdrop="static" size='md'>
        <ModalHeader toggle={toggle}>Update Attribute</ModalHeader>
        <ModalBody>
          {requestError.show_alert && (
            <Alert
              color="danger"
              role="alert"
              isOpen={requestError.show_alert}
              toggle={resetErrorAlert}
            >
              <i className="mdi mdi-block-helper mr-2"></i>
              {requestError.message}
            </Alert>
          )}
          <AvForm className="needs-validation" onValidSubmit={handleSubmit}>
            <ModalBody>
              <Row>
                <Col md="12">

                  <FormGroup>
                    <Label for="name">Name</Label>
                    {/* <Input
                    type="text"
                    name="name"
                    id="name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  /> */}
                    <AvField
                      name="name"
                      placeholder="Enter attribute name ..."
                      type="text"
                      className="form-control"
                      value={name}
                      validate={{
                        required: {
                          value: true,
                          errorMessage: 'Name is required'
                        }
                      }}
                    />
                  </FormGroup>
                </Col>
                <Col md="12">
                  <FormGroup>
                    <Label>Badge</Label>
                    <Select
                      options={badges}
                      styles={styles}
                      onChange={handleBadgeSelection}
                      value={selectedBadge}
                    />
                  </FormGroup>
                </Col>
                <Col md="12">
                  <FormGroup>
                    <Label for="questions">Select Questions</Label>
                    <Select
                      styles={styles}
                      options={questions}
                      isClearable={false}
                      isMulti
                      value={question}
                      onChange={handleQuestionToggle}
                    />
                    {/* </FormGroup> */}
                  </FormGroup>
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter>
              <Button
                disabled={sectionLoading}
                type="button"
                color="light"
                onClick={toggle}
              >
                Close
              </Button>
              <Button type="submit" color="success">
                {sectionLoading ? 'Updating ...' : 'Update Attribute'}
              </Button>
            </ModalFooter>
          </AvForm>
        </ModalBody>

      </Modal>
    </React.Fragment>
  );
};

export default EditSectionModal;